import { onLongPress, type OnLongPressOptions } from "@vueuse/core"
import type { ObjectDirective } from "vue"
import { isMobileDevice } from "@/helper/app/device-helper"

type BindingValueFunction = (evt: PointerEvent) => void
type BindingValueArray = [BindingValueFunction, OnLongPressOptions]

const cleanupByElement = new WeakMap<HTMLElement, () => void>()

// Keep long-press behavior mobile-only.
export const vOnLongPress: ObjectDirective<HTMLElement, BindingValueFunction | BindingValueArray> =
  {
    mounted(el, binding) {
      if (!isMobileDevice()) {
        return
      }

      // Register through the composable so VueUse can clean up side effects on unmount.
      const cleanup =
        typeof binding.value === "function"
          ? onLongPress(el, binding.value, { modifiers: binding.modifiers })
          : onLongPress(el, ...binding.value)

      cleanupByElement.set(el, cleanup)
    },
    unmounted(el) {
      cleanupByElement.get(el)?.()
      cleanupByElement.delete(el)
    }
  }
